module.exports = __webpack_public_path__ + "static/media/zoomorphic-bowl.13721efc.jpg";